// "YYYY-MM-DD" (or an ISO timestamp) as a local calendar day, so a due date never slips a day across timezones.
const toLocalDay = (value) => {
  const [y, m, d] = String(value).slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d);
};

// Whole days from today to the date: negative once it has passed, null with no date.
export const daysUntil = (value) => {
  if (!value) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((toLocalDay(value) - today) / 86400000);
};

export const formatDay = (value) =>
  value ? toLocalDay(value).toLocaleDateString("en-GB", { day: "numeric", month: "short" }) : "—";

// How a due date reads: red once past, blue inside the next 7 days. `done` items never warn.
export const dueTone = (value, done) => {
  const days = daysUntil(value);
  if (done || days === null) return { days, tone: "" };
  if (days < 0) return { days, tone: "late" };
  return { days, tone: days <= 7 ? "soon" : "" };
};
